<template>
    <main id="content-main" class="section content-main">
        <article>
          <div v-if="loading">
            <h1>Loading…</h1>
          </div>
          <div v-else-if="error">
                <h1>Error</h1>
                <p>{{errorMsg}}</p>
          </div>
          <div v-else>
            <h1>{{name}} <span class="pasticcioID">(Pasticcio ID: {{$route.params.id}})</span></h1>
            <div class="basic-data-block">
              <ul id="placeDataList" class="blockGroup">
                <li>
                    <font-awesome-icon icon="map" />
                    <a v-bind:href="'https://www.geonames.org/'+geonameID" target="_blank">Information on Geonames</a>
                </li>
                <li v-if="location != null">
                    <font-awesome-icon icon="location-pin" />
                    {{location[0]}}, {{location[1]}}
                </li>
              </ul>
            </div>

              <div class="person-tabs">
                  <b-tabs content-class="mt-3">
                      <b-tab v-if="location != null" title="Map" active>

                          <v-select
                                  v-model="mapStyle"
                                  :items="mapStyleItems"
                                  item-text="label"
                                  item-value="value"
                                  label="Select a current or historical map:"
                                  return-object
                                  single-line
                          ></v-select>

                          <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true"
                                  data-projection="EPSG:4326" style="height: 400px">
                              <vl-view :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>

                              <vl-layer-tile id="osm" v-if="mapStyle.value === 'current'">
                                  <vl-source-osm></vl-source-osm>
                              </vl-layer-tile>

                              <vl-layer-tile id="wms" v-if="mapStyle.value === 'historical'">
                                  <vl-source-wms format="image/png"
                                  url="https://ref.de.dariah.eu/geoserver/historic/wms"
                                  layers="historic:cntry1783"
                                  version="1.1.1"
                                  tiled="true"
                                  tilesOrigin="-180,-90"></vl-source-wms>
                              </vl-layer-tile>

                              <vl-overlay id="overlay" :position="location">
                                  <template slot-scope="scope">
                                      <div class="overlay-content">
                                          <font-awesome-icon icon="location-pin" />
                                          <div class="geoname">{{ name }}</div>
                                      </div>
                                  </template>
                              </vl-overlay>
                          </vl-map>
                      </b-tab>
                      <b-tab v-if="relatedOrganisations && relatedOrganisations.length" title="Related Organisations">
                          <div class="past-list" v-for="org in relatedOrganisations" :key="org.id">
                              <font-awesome-icon icon="building-columns" /><router-link v-bind:to="'/database/org/' + org.id">{{ org.name }} <span class="pasticcioID">(Pasticcio ID: {{ org.id }})</span>
                              </router-link>
                          </div>
                      </b-tab>
                      <b-tab v-if="relatedPersons && relatedPersons.length" title="Related Persons">
                          <div class="past-list" v-for="pers in relatedPersons" :key="pers.id">
                              <font-awesome-icon icon="user" /><router-link v-bind:to="'/database/person/' + pers.id">{{ pers.name }} <span class="pasticcioID">(Pasticcio ID: {{ pers.id }})</span>
                              </router-link>
                          </div>
                      </b-tab>
                  </b-tabs>
              </div>
           </div>
        </article>
    </main>
</template>



<script>

    import axios from "axios";

    export default {
      data () {
            return {
                id: "",
                name: "",
                geonameID: "",
                location: [0, 0],
                relatedOrganisations: null,
                relatedPersons: null,
                loading: false,
                error: false,
                errorMsg: "",
                zoom: 5,
                center: [0, 0],
                rotation: 0,
                mapStyle: {label: 'Historical map of 1783 (\u00A9 ThinkQuest Team C006628)', value: 'historical'},
                mapStyleItems: [
                    { label: 'Historical map of 1783 (\u00A9 ThinkQuest Team C006628)', value: 'historical'},
                    { label: 'Current map (\u00A9 Open Street Map)', value: 'current'},
                ],
            }
          },
      mounted() {
          this.loading = true;
        axios.get("https://metadata.pasticcio-project.eu/apps/pasticcio_backend/xqueries/getPlace.xql",
          {
            params:{
              id: this.$route.params.id
              }
          })
        .then(
          response => {
            this.id = response.data.id;
            this.name = response.data.name;
            this.geonameID = response.data.geonameID;
            if(response.data.location == null) {
                this.location = null;
            }else {
                let lat = parseFloat(response.data.location.split(',')[1]);
                let long = parseFloat(response.data.location.split(',')[0])
                this.location = [lat, long];
                this.center = [lat, long];
            }
          }
        )
        .catch(error => {
            console.log("ERROR: " + error);
            this.error = true;
            this.errorMsg = error;
          })
        .finally(() => this.loading = false)

          axios.get("https://metadata.pasticcio-project.eu/apps/pasticcio_backend/xqueries/getRelatedOrganisations.xql",
              {
                  params:{
                      id: this.$route.params.id
                  }
              })
              .then(
                  response => {
                      if(response.data == null || Array.isArray(response.data))
                          this.relatedOrganisations = response.data;
                      else
                          this.relatedOrganisations = [response.data];
                  }
              )
              .catch(error => {
                  console.log("ERROR: " + error);
              })

          axios.get("https://metadata.pasticcio-project.eu/apps/pasticcio_backend/xqueries/getRelatedPersons.xql",
              {
                  params:{
                      id: this.$route.params.id
                  }
              })
              .then(
                  response => {
                      if(response.data == null || Array.isArray(response.data))
                          this.relatedPersons = response.data;
                      else
                          this.relatedPersons = [response.data];
                  }
              )
              .catch(error => {
                  console.log("ERROR: " + error);
              })
      },
    }

</script>

<style scoped lang="css">
    @import "../styles/content.css";
</style>


